import {type Observable, catchError, startWith} from 'rxjs'

export const catchSwitchMapError =
  (errorAction: (error: any) => any) =>
  <T>(source: Observable<T>) =>
    source.pipe(catchError((error, innerSource) => innerSource.pipe(startWith(errorAction(error)))))
